import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import './BackerAvatarItem.css'

class BackerAvatarItem extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	fallbackAvatar: ''
	    };
	    this.buildFallbackAvatar = this.buildFallbackAvatar.bind(this);
	}

	componentDidMount() {
	    this.buildFallbackAvatar();
	}

	buildFallbackAvatar(){
		let name = this.props.data.name;
		if(!this.props.data.name){
			return 'A'
		}
		var initials = name.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);
		initials = initials.join('');
		return initials
	}

	render() {
		return (
			<div className="backerContainer" data-tip={this.props.data.name ? this.props.data.name : 'Anonymous'}>
				<ReactTooltip effect="solid"/>
				<div className="backerAvatar">
					{this.props.data.avatar_url === "" || this.props.data.avatar_url === 'null' || this.props.data.avatar_url === null || this.props.data.avatar_url === undefined ? 
						<div className="defaultAvatar">{this.buildFallbackAvatar()}</div>
					: <img src={this.props.data.avatar_url} alt="Avatar" />
					}
				</div>
				{this.props.data.amount &&
					<div className="backerAmount">
						€{this.props.data.amount}
					</div>
				}
			</div>
		);
	}
}

export default BackerAvatarItem;



// WEBPACK FOOTER //
// ./src/components/Explore/BackerAvatarItem.js